import React from 'react';
import {useTranslation} from 'react-i18next';
import {toPriceStr} from '@/utils';
import globalStore from '@/services/global.state';
import useWithdrawStore from '../withdraw.store';

const iconWallet = require('@assets/imgs/withdraw/cash.webp');
const iconWithdraw = require('@assets/imgs/withdraw/withdraw.webp');
const bg1 = require('@assets/imgs/withdraw/bg.png');
const bg2 = require('@assets/imgs/withdraw/bg01.png');

const orangeCardStyle: React.CSSProperties = {
  background: `url(${bg1}) no-repeat center center`,
  backgroundSize: '100% 100%',
  color: '#814000',
};
const blueCardStyle: React.CSSProperties = {
  background: `url(${bg2}) no-repeat center center`,
  backgroundSize: '100% 100%',
  color: '#00407F',
};

export interface WithdrawBalanceProps {
  cash?: number;
  withdrawable?: number;
  onRefresh?: () => void;
}

const WithdrawBalance: React.FC<WithdrawBalanceProps> = props => {
  const {cash = 0, withdrawable = 0} = props;
  const {i18n} = useTranslation();
  const withdrawInfo = useWithdrawStore(s => s.info);
  console.log('withdrawInfo>>>', withdrawInfo);
  console.log(111);

  const renderCard = (
    title: string,
    amount: number,
    style: React.CSSProperties,
    icon: any,
  ) => {
    return (
      <div
        className="relative rounded-[0.384rem] px-2 py-5 overflow-hidden flex items-center gap-2 flex-1 basis-0"
        style={style}>
        <img src={icon} alt={title} className="w-8 object-contain" />
        {/* 只要 style 的 color 属性 */}
        <div
          className="flex-1 flex flex-col gap-1"
          style={{color: style.color}}>
          {/* 字体颜色是 */}
          <div className="text-sm font-[600]">{title}</div>
          <div className="text-base font-[900] leading-none font-inter break-all">
            {toPriceStr(amount, {
              thousands: true,
              spacing: true,
              currency: globalStore.currency,
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex items-start gap-2 mt-4 w-full">
      {renderCard(
        i18n.t('me.money.cashBalance'),
        cash,
        orangeCardStyle,
        iconWallet,
      )}
      {renderCard(
        i18n.t('transfer-page.label.withdrawable'),
        withdrawable,
        blueCardStyle,
        iconWithdraw,
      )}
    </div>
  );
};

export default React.memo(WithdrawBalance);
